import NumericEvaluator from './NumericEvaluator';

export default class LessThanEvaluator extends NumericEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'less_than';
  }

  validate() {
    this.mutator[1] = this.mutator[0];
    this.mutator[0] = null; // Hack to validate any type of number against super class
    this.isValid = super.validate();
    this.isValid = this.isValid && !Number.isNaN(parseInt(`${this.mutator[1]}`, 10));
    if (this.isValid && this.value !== null && this.value !== undefined) {
      this.mutator[1] = parseInt(`${this.mutator[1]}`, 10);
      this.value = parseInt(`${this.value}`, 10); // checked if numeric in parent class
      this.isValid = this.value < this.mutator[1];
    }
    return this.isValid;
  }

  getMessage(validatorDictionary) {
    if (this.isValid) {
      return {
        type: 'valid',
        message: '',
      };
    }
    const func = validatorDictionary[this.evaluatorName];
    return {
      type: 'error',
      message: func(this.friendlyFieldName, this.mutator[1]),
    };
  }
}
